module.exports = {
	"360": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"autoHide": false
		}
	},
	"wipeaway": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"autoHide": false
		}
	},
	"image": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"fitting": "Fit",
			"position": "Center",
			"autoHide": false
		}
	},
	"button": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"autoHide": false
		},
		"actions": {
			"event": "click",
			"clickActions": "",
			"mouseOverActions": "",
			"mouseOutActions": "",
			"swipeLeftActions": "",
			"swipeRightctions": "",
			"swipeUpActions": "",
			"swipeDownActions": "",
			"clickthroughUrl": "https://www.ivo.io"
		}
	},
	"rectangle": {
		"css": {
			"width": 150,
			"height": 150,
			"backgroundColor": "#666666",
			"borderStyle": "solid",
			"borderColor": "#000000",
			"borderWidth": 1,
			"borderRadius": 1
		},
		"settings": {
			"name": "",
			"autoHide": false
		}
	},
	"swipegallery": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"autoPlay": false,
			"autoPlayDelay": 0,
			"autoHide": false
		}
	},
	"effectlayer": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"effect": "snow",
			"size": 2,
			"speed": 10,
			"intensity": 10,
			"autoHide": false
		}
	},
	"textbox": {
		"css": {
			"width": 150,
			"height": 150,
			"fontSize": 20,
			"lineHeight": "20px"
		},
		"settings": {
			"name": "",
			"text": ""
		}
	},
	"video": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"fitting": "Stretch",
			"position": "Center",
			"controls": true,
			"autoPlay": true,
			"mute": true,
			"loop": false,
			"autoHide": false,
			"syncWithTimeline": false
		}
	},
	"youtube": {
		"css": {
			"width": 300,
			"height": 169
		},
		"settings": {
			"name": "",
			"youtubeURL": "https://www.youtube.com/watch?v=qIf5ImIOtxM",
			"autoHide": false,
			"autoplay": false,
			"controls": false
		}
	},
	"imagezoom": {
		"css": {
			"width": 150,
			"height": 150
		},
		"settings": {
			"name": "",
			"src": null,
			"assetIds": [],
			"autoHide": false
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/App/Builder/config/components.json
// module id = ./app/javascript/packs/App/Builder/config/components.json
// module chunks = 0 1